export default {
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        dialog: true,
    }),
    methods: {
        emitirRelatoriosAction() {
            this.$emit('emitirRelatoriosAction', false);
            this.dialog = false;
        },
        fecharAction() {
            this.$emit('fecharAction', false);
            this.dialog = false;
            setInterval(() => {
                window.location.reload();
            },  750);
        },
    }
};